import React from 'react'
import { Button, ToggleInput } from '@demandlocal/components'
import { FieldValues, FormProvider, useForm } from 'react-hook-form'
import { ReactComponent as TestIcon } from '../../../images/icons/link_outside.svg'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router'

const CreateTag = ({}: {}): JSX.Element => {
  const formContext = useForm<FieldValues>({
    mode: 'onSubmit',
  })
  const navigate = useNavigate()

  const {
    handleSubmit,
    formState: { isDirty },
  } = formContext

  const onSubmit = (): void => {
    try {
    } catch (err) {
      toast.error('error submitting tag', { duration: 5000 })
    }
  }

  return (
    <FormProvider {...formContext}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-1 flex-col px-12 pt-12 font-Spartan h-[100vh]">
          <div className="flex flex-col gap-3 overflow-y-auto">
            <div className="flex flex-row justify-start">
              <span className="font-bold text-[28px]">Add a tag</span>
            </div>
            <span>
              Key performance indicators are the success metrics used to track and
              optimize performance throughout your campaign.
            </span>
            <div className="border-2 p-2 border-gray-200 rounded-md flex flex-row justify-between items-center">
              <div className="flex flex-col">
                <span className="font-bold p-2">
                  Can you grant access to your tag manager?
                </span>
                <div className="flex flex-row justify-between p-2">
                  <span className="text-xs">
                    The reason we ask for access to your tag manager is to implement our
                    tags to ensure easier changes and updates, better tracking and to
                    secure a low impact on performance.
                  </span>
                </div>
                <div className="flex flex-row justify-between p-2">
                  <span className="text-xs">
                    No worries, this process is completely secure and your data will only
                    be used for creating a tag. Please go to your tag manager and give
                    access to{' '}
                    <span className="text-primary-persian-blue font-bold">
                      integrations@link1data.com.
                    </span>
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 gap-4">
                <div className="flex flex-row justify-end pr-4">
                  <ToggleInput name={'ga_access'} label={'Access GA'} />
                </div>
                <div className="w-[200px]">
                  <Button
                    variant="primary"
                    rightSlot={<TestIcon className="stroke-white fill-white" />}
                    onClick={(e) => {
                      e.preventDefault()
                      window.open('https://tagmanager.google.com/', '_blank')
                    }}>
                    Open Tag Manager
                  </Button>
                </div>
              </div>
            </div>
            <div className="border-2 p-2 border-gray-200 rounded-md flex flex-col">
              <div className="flex flex-row justify-between p-2 justify-between items-center">
                <div className="flex flex-col">
                  <span className="font-bold">
                    Can you grant access to your Google Analytics (GA4) account?
                  </span>
                  <span className="text-xs">
                    Giving us access to your Google Analytics will ensure...
                  </span>
                </div>
                <ToggleInput name={'ga4_access'} label={'Access GA4'} />
              </div>
            </div>
            <div className="border-2 p-2 border-gray-200 rounded-md flex flex-col">
              <div className="flex flex-row justify-between p-2 justify-between items-center">
                <div className="flex flex-col">
                  <span className="font-bold">Let us create a new tag for you</span>
                  <span className="text-xs">
                    Explanation as to why this option works better
                  </span>
                </div>
                <ToggleInput
                  name={'auto_create_tag'}
                  label={'Create Tag Automatically'}
                />
              </div>
            </div>
          </div>
          <div className={'flex justify-between py-5 border-t mt-auto'}>
            <Button
              variant={'tertiary'}
              onClick={(e) => {
                e.preventDefault()
                navigate(-1)
              }}>
              Back
            </Button>
            <Button variant={'primary'}>Continue</Button>
          </div>
        </div>
      </form>
    </FormProvider>
  )
}

export default CreateTag
